<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import CGJComponent from "@/component/project/CGJComponent.vue";

@Component({
  components: {CGJComponent, NavBar}
})
export default class CGJView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <CGJComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>